<template>
    <v-item-group class="teachin-list" mandatory>
      <draggable v-model="list" v-bind="dragOptions" :move="onMove" @end="onDraggableEnd" draggable=".teachin-list__item--sortable">
      <v-item class="teachin-list__item" 
      :class="`${isSelected(section)? 'teachin-list__item--selected': ''} ${!section.sortable? 'teachin-list__item--fixed':'teachin-list__item--sortable'}`" 
      @change.stop="itemChanged(section)"
      v-for="(section, index) in list" :key="index">
            <v-card
              :color="isSelected(section) ? 'primary' : 'grey lighten-3'"
              elevation="0"
              class="d-flex align-center"
              dark
              height="50"
              @click="toggleSelected(section)"
            >
            <div class="teachin-list__item-wrapper">
              <span class="teachin-list__item-title" 
              :class="`${isSelected(section)? 'teachin-list__item-title--selected': ''}`"
              >{{ $t(section.label) }}</span>
              <v-btn icon elevation="0" :disabled="section.showAlways" @click.stop="updateSectionVisibility(index, !section.active)">
                <v-icon :color="isSelected(section)?  'white': '#1B99A7'" large v-if="section.active">mdi-eye-outline</v-icon>
                <v-icon :color="isSelected(section)?'white':'#6c6c6c'" large v-else>mdi-eye-off-outline</v-icon>
              </v-btn>
            </div>
            </v-card>
          </v-item>
        </draggable>
  </v-item-group>
  
</template>

<script>
import { cloneDeep } from 'lodash';
import draggable from 'vuedraggable'

  export default {
    name: 'TeachinSectionList',
    components: {draggable},
    props:{
      sections: {
        type: Array,
        required: true
      }
    },
    created(){
      this.init();
    },
    data(){
      return {
        list: null,
        activeSection: null 
      };
    },
    computed: {
      dragOptions() {
        return {
          animation: 0,
          group: "sections",
        };
      },
      isSelected(){
        return (section) => {
          if(!this.activeSection || !this.activeSection.name) return false;
          return this.activeSection.name === section.name;
        }
      }
    },
    watch:{
        sections: {
          handler(){
            const list = cloneDeep(this.sections);
            this.list = cloneDeep(list);
          },
          deep: true,
        }
    },
    methods:{
      init(){
        const list = cloneDeep(this.sections);
        this.list = cloneDeep(list);
        const activeSection = list? cloneDeep(list).shift(): null;
        this.itemChanged(activeSection);
      },
      itemChanged(item){
        if(!item){
          this.activeSection = null;
          return;
        }
        this.activeSection = cloneDeep(item);
        this.$emit('active', cloneDeep(item));

      },
      updateSectionVisibility(index, value){
        this.list[index].active = value;
        this.$emit('syncSections', cloneDeep(this.list));
      },
      onMove({ relatedContext, draggedContext }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return (
          (!relatedElement || relatedElement.sortable) && draggedElement.sortable
        );
      },
      toggleSelected(section){
        if(this.activeSection && this.activeSection.name === section.name){
          this.activeSection = null;
        }else{
          this.activeSection = cloneDeep(section);
        }
        this.itemChanged(section);
      },
      onDraggableEnd(){
        this.$emit('syncSections', cloneDeep(this.list));
      }
    }
  }
</script>

<style lang="scss" scoped>
  .teachin-list{
    & > div{

    display: flex;
    flex-wrap: wrap;
    }
    &__item{
      flex: 1;
      margin: .2em;
      display: flex;
      justify-content: center;
      align-items: center;
      

      &-wrapper{
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .2em;

        & ::v-deep .theme--dark.v-icon{
          font-size: 22px!important;
        }
        & ::v-deep .theme--dark.v-btn.v-btn--disabled .v-icon, .theme--dark.v-btn.v-btn--disabled .v-btn__loading{
          color: #c7c7c7!important;
        }
      }

      &-title{
        color: #1B99A7;
        font-family: Arial, sans-serif;
        font-size: 14px;
        line-height: 16.1px;
        font-weight: 700;
        padding-left: .5em;
        &--selected{
          color: #fff!important;
        }

      }
    }

   
  }
</style>
